import mobileView from './mobile.utils'

export const chartDataFormat = (labels, percentData, bgColor, datasetLabel) => {
  let obj = {}
  obj = {
    labels: labels,
    datasets: [
      {
        label: datasetLabel,
        data: percentData,
        backgroundColor: bgColor
      }
    ]
  }
  return obj
}

export const calcPercent = (data) => {
  let percent = []
  let total_sum = data.reduce((a, b) => a + b, 0)
  for (let i = 0; i < data.length; i++) {
    percent.push(Math.round((data[i] / total_sum) * 100))
  }
  return percent
}

export const convertDate = (dateString) => {
  let p = dateString.split(/\D/g)
  return [p[2], p[1], p[0]].join('.')
}

export const getNth = (s, c, n) => {
  let idx
  let i = 0
  let newS = ''
  do {
    idx = s.indexOf(c)
    newS += s.substring(0, idx)
    s = s.substring(idx + 1)
  } while (++i < n && (newS += c))
  return newS
}

//Input: '2018-10-10T06:44:00.6', Output: '10.10.2018 klo 06:44'
export const formatDateAndTime = (dt) => {
  let words = dt.split('T')
  let date = convertDate(words[0])
  let time = getNth(words[1], ':', 2)
  let fdt
  if (mobileView) {
    fdt = date
  } else {
    fdt = date + ' klo ' + time
  }
  return fdt
}

export const convertInvoiceStateNames = (invoiceState) => {
  switch (invoiceState) {
    case 'Draft':
      return 'names.luo' //'Luonnos'
    case 'Sent':
      return 'names.lahe' //'Lähetetty'
    case 'Paid':
      return 'names.maks' //'Maksettu'
    case 'UnderProcessing':
      return 'names.kasi' //'Käsittelyssä
    case 'Paid (MP)':
      return 'names.muistutusPoistettu' //'Maksettu MP'
  }
}

export const convertMonthNames = (month) => {
  switch (month) {
    case 'January':
      return '1'
    case 'February':
      return '2'
    case 'March':
      return '3'
    case 'April':
      return '4'
    case 'May':
      return '5'
    case 'June':
      return '6'
    case 'July':
      return '7'
    case 'August':
      return '8'
    case 'September':
      return '9'
    case 'October':
      return '10'
    case 'November':
      return '11'
    case 'December':
      return '12'
  }
}

export const labelInvoiceMonthlyArray = (array) => {
  let list = []
  for (var i = 0; i < array.length; i++) {
    list.push(convertMonthNames(array[i]))
  }
  return list
}

export const labelInvoiceArray = (array) => {
  let list = []
  for (var i = 0; i < array.length; i++) {
    list.push(convertInvoiceStateNames(array[i]))
  }
  return list
}

export const reverseAndReduce = (array) => {
  const selectedSalaryIds = array
  //console.log('Inside reverseAndReduce:: ', selectedSalaryIds)

  let b = selectedSalaryIds.reverse()
  //console.log('Inside reverseAndReduce:: ', b)

  const filteredArr = b.reduce((acc, current) => {
    const x = acc.find(
      (item) => `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
    )
    if (!x) {
      return acc.concat([current])
    } else {
      return acc
    }
  }, [])

  return filteredArr
}

export const concatReverseReduceSortFunction = (array1, array2) => {
  let array3 = array1.concat(array2)
  //console.log('Inside concatReverseReduceSortFunction array3:: ', array3)

  let array4 = reverseAndReduce(array3)
  //console.log('Inside concatReverseReduceSortFunction array4:: ', array4)

  //console.log('Inside concatReverseReduceSortFunction:: ', array4.sort((a, b) => (a.created < b.created) ? 1 : -1))
  return array4.sort((a, b) => (a.created < b.created ? 1 : -1))
}
